import React from "react";
import { useAppContext } from "../../context/AppContext";
import { AppTypography } from "../common/Typography";
import AppButton from "../common/Button";
import { useTheme } from "../../theme/ThemeContext";
import {
  Box,
  Paper,
  IconButton,
  Divider,
} from "@mui/material";
import {
  Close as CloseIcon,
  CheckCircle as CheckCircleIcon,
} from "@mui/icons-material";
import styled from "@emotion/styled";
import { usePreserveStoreIdNavigate } from "./usePreserveStoreIdNavigate";

const PopupOverlay = styled(Box)({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
});

const PopupContent = styled(Paper)({
  maxWidth: "500px",
  width: "90%",
  maxHeight: "80vh",
  overflow: "auto",
  borderRadius: "16px",
  position: "relative",
});

const Popup = ({ isOpen, onClose, title, message, image, handleButton }) => {
  const navigate = usePreserveStoreIdNavigate();
  const { clearCart } = useAppContext();
  const theme = useTheme();

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleAction = () => {
    if (handleButton) {
      handleButton();
    } else {
      clearCart();
      navigate("/");
    }
  };

  if (!isOpen) return null;

  return (
    <PopupOverlay onClick={handleClose}>
      <PopupContent onClick={(e) => e.stopPropagation()}>
        <Box sx={{ p: 3 }}>
          {/* Close Button */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
            <IconButton
              onClick={handleClose}
              sx={{
                color: theme?.text_color,
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.04)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Content */}
          <Box sx={{ textAlign: "center" }}>
            {image && (
              <Box sx={{ mb: 3 }}>
                <img
                  src={image}
                  alt="Success"
                  style={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </Box>
            )}

            <CheckCircleIcon
              sx={{
                fontSize: 64,
                color: "#4caf50",
                mb: 2,
              }}
            />

            <AppTypography
              variant="h4"
              style={{
                fontWeight: 700,
                fontSize: "1.8rem",
                marginBottom: "0.5rem",
              }}
              sx={{ mb: 2 }}
            >
              {title || "Success!"}
            </AppTypography>

            <AppTypography
              variant="body1"
              style={{
                opacity: 0.8,
              }}
              sx={{ mb: 3 }}
            >
              {message || "Your order has been placed successfully!"}
            </AppTypography>

            <Divider sx={{ my: 2 }} />

            <AppButton
              variant="contained"
              size="large"
              onClick={handleAction}
              sx={{
                backgroundColor: theme?.primary_color,
                "&:hover": {
                  backgroundColor: theme?.primary_color,
                  opacity: 0.9,
                },
              }}
            >
              Continue Shopping
            </AppButton>
          </Box>
        </Box>
      </PopupContent>
    </PopupOverlay>
  );
};

export default Popup;